import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {QuillModule} from 'ngx-quill';
import {SharedModule} from '../shared/shared.module';
import {EmailComposerComponent} from './email-composer/email-composer.component';
import {EmailListIndexComponent} from './email-list-index/email-list-index.component';
import {EmailOptionsComponent} from './email-options/email-options.component';
import {EmailPreviewComponent} from './email-preview/email-preview.component';
import {EmailRoutingModule} from './email-routing.module';

@NgModule({
    imports: [
        SharedModule,
        FormsModule,

        QuillModule,

        EmailRoutingModule
    ],
    declarations: [EmailListIndexComponent, EmailOptionsComponent, EmailComposerComponent, EmailPreviewComponent]
})
export class EmailModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email.module.ts